import { render, staticRenderFns } from "./ReceivedHistory.vue?vue&type=template&id=24c25cb8&scoped=true"
import script from "./ReceivedHistory.vue?vue&type=script&lang=js"
export * from "./ReceivedHistory.vue?vue&type=script&lang=js"
import style0 from "./ReceivedHistory.vue?vue&type=style&index=0&id=24c25cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c25cb8",
  null
  
)

export default component.exports